export default __webpack_public_path__ + "static/media/Atla-Logo-Tagline-TEAL-RGB.9954fc3e.jpg";